// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refTrkPopup {
  width: 500px !important;
  min-width: 500px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/dispatches/ref-tracking/ref-tracking.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,2BAAA;AACJ","sourcesContent":[".refTrkPopup {\n    width: 500px !important;\n    min-width: 500px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
